import { translate } from '@/ui/i18n';
import {
  FormComponent,
  GenericExternalPage,
} from '@/ui/pages/external/components/GenericExternalPage';

export function GenericExternalPageVenue({
  children,
}: {
  children: FormComponent;
}) {
  return (
    <GenericExternalPage
      welcomeText={translate('External.welcome-description-venue')}
    >
      {children}
    </GenericExternalPage>
  );
}
